"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRoomTransitionRuleSchema = exports.createRoomTransitionRuleSchema = exports.roomTransitionRuleShape = exports.roomTransitionTypeEnum = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (IP Billing Administration, Module 4 — Room Upgrade/Downgrade Rules). */
exports.roomTransitionTypeEnum = zod_1.z.enum(['UPGRADE', 'DOWNGRADE', 'ANY']);
exports.roomTransitionRuleShape = {
    name: zod_1.z.string().min(1).max(255),
    transitionType: exports.roomTransitionTypeEnum,
    maxAutoApprovePercentDifferential: zod_1.z.number().min(0).max(100).optional(),
    requiresApproval: zod_1.z.boolean().optional(),
    approvalMatrixId: zod_1.z.string().uuid().optional(),
};
exports.createRoomTransitionRuleSchema = zod_1.z.object(exports.roomTransitionRuleShape);
exports.updateRoomTransitionRuleSchema = zod_1.z.object(exports.roomTransitionRuleShape).partial();
//# sourceMappingURL=room-transition-rule.schema.js.map